import * as React from 'react';
import { Link } from 'shared/components/Link';

interface Props {
  isIdeaLandingCard?: boolean;
  className?: string;
  url: string;
}

export const Wrapper: React.FC<Props> = ({ isIdeaLandingCard, children, url, className }) => {
  if (isIdeaLandingCard) {
    return <div className={className}>{children}</div>;
  }

  return (
    <Link to={url} className={className}>
      {children}
    </Link>
  );
};
